<template>
  <!-- 我的帖子 -->
  <div class="box">
    <div class="bg2">
      <div class="sec-flex">
        <div
          :class="['flex-txt', active == item.code ? 'cur' : '']"
          v-for="item in dccTypeList"
          :key="item && item.code"
          @click="handleCheck(item)"
        >
          <span>{{ item && item.label }}({{ item.num }})</span>
          <img
            v-show="item.code == active"
            src="../../assets/images/zone/img2.png"
            class="icon1"
            alt=""
          />
        </div>
      </div>
    </div>
    <div class="list">
      <div class="search">
        <div class="left">
          <div
            :class="['item', item.code === kind ? 'color' : '']"
            v-for="item in searchList"
            :key="item && item.code"
            @click="handleClick(item)"
          >
            <img
              v-show="item && item.icon"
              class="img"
              :src="item.code === kind ? item.icon1 : item.icon"
              alt=""
            />
            {{ item && item.label }}
          </div>
        </div>
      </div>
      <DccList ref="dccList" :active="active" :type="active" />
    </div>
  </div>
</template>

<script>
import { dccTypeList, searchList } from './data'
import DccList from './compontents/dccList.vue'
import { getDcc } from '@/api/dcc'
import {debounce} from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  data() {
    return {
      dccTypeList,
      searchList,
      active: 1,
      kind: ''
    }
  },
  components: { DccList },
  methods: {
    handleCheck: debounce(async function(item) {
      this.active = item.code
      this.$refs.dccList.init(this.active, this.kind)
    }, 400),
    handleClick: debounce(function(item) {
      this.kind = item.code
      this.$refs.dccList.init(this.active, this.kind)
    }, 400),
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  mounted() {
    const query = this.$route.query
    console.log(query, '333')
    if (query && Object.keys(query).length > 0) {
      this.active = query.status
    } else {
      this.active = 1
    }
    let params = {
      auditStatus: 0,
      userId: this.userInfo.id,
      pageNo: 1,
      pageSize: 10
    }
    let params1 = {
      auditStatus: 1,
      userId: this.userInfo.id,
      pageNo: 1,
      pageSize: 10
    }
    let params2 = {
      auditStatus: 2,
      userId: this.userInfo.id,
      pageNo: 1,
      pageSize: 10
    }
    Promise.all([getDcc(params), getDcc(params1), getDcc(params2)]).then(
      res => {
        this.dccTypeList[0].num = res[0].data.total || 0
        this.dccTypeList[1].num = res[1].data.total || 0
        this.dccTypeList[2].num = res[2].data.total || 0
      }
    )
  }
}
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.box {
  background: #F9F8F7;
}
.bg1 {
  width: 375px;
  height: 56px;
  img {
    width: 375px;
    height: 56px;
  }
}
.sec-flex {
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  height: 42px;
  align-items: center;
  border-radius: 12px 12px 0 0;
  background: #fff;

  .flex-txt {
    position: relative;
    height: 42px;
    line-height: 42px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 14px;
    color: #656e7f;
    margin-right: 18px;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    &.cur {
      font-weight: 600;
      color: #EB1700;
    }

    .icon1 {
      position: absolute;
      width: 23px;
      bottom: 4px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
.list {
  min-height: calc(100vh - 48px);
  padding-top: 10px;
  .search {
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    box-sizing: border-box;
    margin-bottom: 7px;
    .left {
      display: flex;
      .item {
        height: 22px;
        background: #ffffff;
        border-radius: 30px;
        line-height: 22px;
        text-align: center;
        padding: 0 4px;
        box-sizing: border-box;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #656e7f;
        margin-right: 4px;
        display: flex;
        align-items: center;
        .img {
          width: 10px;
          height: 10px;
          margin-right: 2px;
        }
      }
    }
  }
}
.color {
  color: #EB1700 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/dcc.vue